import React from "react";

const EditableSelect = ({ value, onChange, ariaLabel, options = [] }) => (
  <select
    value={value}
    onChange={onChange}
    aria-label={ariaLabel}
    className="min-h-[3rem] w-full rounded-2xl border border-slate-700 bg-slate-950/80 px-4 py-3 text-sm text-slate-100 outline-none transition-all focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20"
  >
    {options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);

export default EditableSelect;
